import {STREAMS_CREATE_REQUEST, STREAMS_CREATE_SUCCESS, STREAMS_CREATE_FAILURE} from "../../constants/streams/create";
import {apiRequest, streamCreate} from "../../../helpers/api";

export const createStream = data => dispatch => {
  dispatch({type: STREAMS_CREATE_REQUEST});
  const request = () => streamCreate(data);
  return apiRequest(request, dispatch, STREAMS_CREATE_SUCCESS, STREAMS_CREATE_FAILURE);
};
